import { useMediaQuery } from 'react-responsive';

// Can not run on ssr
export const useIsMobile = () => {
  return useMediaQuery({ query: '(max-width: 767px)' });
};
